import * as React from 'react'
import { compose } from 'react-apollo'
import { History, Location } from 'history'
import { NewProjectDialog, ProjectThumb, ProjectNews } from './index'
import { ApolloError } from 'apollo-client'
import Error from '../Shared/Alerts/Error'

import {
  SpinnerDiv,
  DarkMain,
  MainHeader,
  ProjectTools,
  ProjectWorkArea,
  ProjectListArea,
  ToolTitle,
  LeftBlock,
  RightBlock,
  CreateNewProject,
  ViewSection,
  Divider,
  ImageButton,
  BlockImage,
  Alt1Button,
  ToolBar,
  NewsTools,
  NewProjectButton
} from './Styles'
import {
  getRecentProjects,
  RecentProjectsProps,
  RecentProjectsResult,
  ProjectType
} from './projectQueries'

const NoPicture = require('./no-photo.svg')

const showNews = false
const news = []

type InputProps = {
  loading: boolean
  recentProjects: RecentProjectsResult
  error?: ApolloError
  history: History
  location: Location
}

type State = {
  newProject: boolean
  error: string | undefined
}

type WrappedProps = RecentProjectsProps & InputProps

class ProjectMainView extends React.Component<WrappedProps, State> {
  constructor(props: WrappedProps) {
    super(props)
    this.state = { newProject: false, error: undefined }
  }

  componentDidMount() {
    if (!this.props.loading && this.props.error) {
      this.setState({ error: this.props.error.message })
    }
  }

  render() {
    const { loading, recentProjects = [], history } = this.props
    return (
      <DarkMain className={'page-main'}>
        <SpinnerDiv>
          {loading && <div className="spinner" />}
          {this.state.error && <Error>{this.state.error}</Error>}
          <MainHeader>Dashboard</MainHeader>
          <ViewSection key={'projects'}>
            <ProjectTools>
              <ToolTitle>Your latest projects</ToolTitle>
              <Alt1Button onClick={() => history.push('/projects')}>
                ALL PROJECTS
              </Alt1Button>
            </ProjectTools>
            <ProjectWorkArea>
              <ProjectListArea>
                <CreateNewProject
                  onClick={() => this.setState({ newProject: true })}
                >
                  <NewProjectButton>+ CREATE NEW PROJECT</NewProjectButton>
                </CreateNewProject>
                {recentProjects.map((project: ProjectType, indx) => (
                  <ProjectThumb
                    key={indx}
                    project={project}
                    history={history}
                  />
                ))}
              </ProjectListArea>
            </ProjectWorkArea>
          </ViewSection>
          {showNews && (
            <ViewSection key={'news'}>
              <LeftBlock>
                <NewsTools>
                  <ToolBar>
                    <ToolTitle>What's new?</ToolTitle>
                    <Alt1Button>ALL NEWS</Alt1Button>
                  </ToolBar>
                </NewsTools>
                <Divider />
                {news.map((story, indx) => (
                  <ProjectNews key={indx} {...story} />
                ))}
              </LeftBlock>
              <RightBlock>
                <BlockImage>
                  <img
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                    src={NoPicture}
                  />
                  <ImageButton>LEARN MORE</ImageButton>
                </BlockImage>
              </RightBlock>
            </ViewSection>
          )}
          <NewProjectDialog
            isOpen={this.state.newProject}
            closeDialog={() => this.setState({ newProject: false })}
          />
        </SpinnerDiv>
      </DarkMain>
    )
  }
}

export default compose(getRecentProjects<InputProps>())(ProjectMainView)



// WEBPACK FOOTER //
// ./src/Components/Projects/ProjectDesktop.tsx